/**
 * ════════════════════════════════════════════════════════════════════
 * KEEP MEMORIZ — assets/blog.js
 * Version i18n : FR/EN via window.KM_LANG
 * ════════════════════════════════════════════════════════════════════
 */

var KM_LANG = (window.KM_LANG || 'fr').toLowerCase();

/* ── UI strings ── */
var BLOG_UI = KM_LANG === 'en' ? {
  allArticles: 'All <em>articles</em>',
  catLabels: {
    'tous': 'All <em>articles</em>',
    'mariage': '<em>Wedding</em> articles',
    'anniversaire': '<em>Birthday</em> articles',
    'baby-shower': '<em>Baby shower</em> articles',
    'evg': '<em>Bachelorette / Bachelor</em> articles',
    'conseils': 'Practical <em>tips</em>',
    'photographie': '<em>Photography</em> articles',
    'decoration': '<em>Decoration</em> articles'
  },
  resultsFor: 'Results for',
  noResults: 'No results for',
  articlesFound: 'article(s) found for',
  loadMore: 'Load more articles',
  remaining: 'remaining',
  readCta: 'Read →',
  min: 'min'
} : {
  allArticles: 'Tous les <em>articles</em>',
  catLabels: {
    'tous': 'Tous les <em>articles</em>',
    'mariage': 'Articles <em>Mariage</em>',
    'anniversaire': 'Articles <em>Anniversaire</em>',
    'baby-shower': 'Articles <em>Baby shower</em>',
    'evg': 'Articles <em>EVJF / EVG</em>',
    'conseils': '<em>Conseils</em> pratiques',
    'photographie': 'Articles <em>Photographie</em>',
    'decoration': 'Articles <em>Décoration</em>'
  },
  resultsFor: 'Résultats pour',
  noResults: 'Aucun résultat pour',
  articlesFound: 'article(s) trouvé(s) pour',
  loadMore: "Charger plus d'articles",
  remaining: 'restant',
  readCta: 'Lire →',
  min: 'min'
};

/* ── Articles data ── */
var ARTICLES_FR = [
  {
    id: 'qr-code-mariage-guide-complet',
    cat: 'mariage', catLabel: 'Mariage', emoji: '💍',
    gradient: 'linear-gradient(145deg,#2C1A14,#7A4A2C,#C9A96E)',
    avatarColor: '#C9A96E',
    image: 'https://cdn.shopify.com/s/files/1/0731/1668/0457/files/blog-carte-mariage.webp?v=1773846341',
    title: 'QR code mariage : le guide complet pour les futurs mariés',
    excerpt: 'Un QR code sur chaque table, et vos invités partagent leurs photos sans rien installer. Fonctionnement, placement, résultats concrets.',
    date: '15 janvier 2025', readTime: 8, large: true,
    tags: ['qr code','mariage','guide','photos','invités','album','partage','table'],
    url: 'https://www.keepmemoriz.com/blogs/infos/qr-code-mariage-le-guide-complet-pour-les-futurs-maries'
  },
  {
    id: 'idees-animation-photo-mariage',
    cat: 'mariage', catLabel: 'Mariage', emoji: '📷',
    gradient: 'linear-gradient(145deg,#1A2C1F,#2A4A30,#6EC98A)',
    avatarColor: '#6EC98A',
    image: 'https://cdn.shopify.com/s/files/1/0731/1668/0457/files/blog-carte-mariage.webp?v=1773846341',
    title: "7 idées d'animation photo pour un mariage mémorable",
    excerpt: 'Photobooth, polaroid, QR code, défis photo... 7 animations testées qui donnent de vraies photos.',
    date: '8 janvier 2025', readTime: 7,
    tags: ['animation','photo','mariage','photobooth','polaroid','qr code','idées'],
    url: 'https://www.keepmemoriz.com/blogs/infos/7-idees-danimation-photo-pour-un-mariage-memorable'
  },
  {
    id: 'livre-or-numerique-mariage',
    cat: 'mariage', catLabel: 'Mariage', emoji: '📖',
    gradient: 'linear-gradient(145deg,#2C2218,#5C3D22,#C9A96E)',
    avatarColor: '#C9A96E',
    image: 'https://cdn.shopify.com/s/files/1/0731/1668/0457/files/blog-carte-mariage.webp?v=1773846341',
    title: "Livre d'or numérique vs traditionnel : lequel choisir pour votre mariage ?",
    excerpt: "Le livre d'or papier a du charme. Le numérique a des photos et des vidéos. Faut-il vraiment choisir ?",
    date: '2 janvier 2025', readTime: 6,
    tags: ["livre d'or",'numérique','traditionnel','mariage','photos','vidéos'],
    url: 'https://www.keepmemoriz.com/blogs/infos/livre-dor-numerique-vs-traditionnel-lequel-choisir-pour-votre-mariage'
  },
  {
    id: 'comparatif-partage-photo-mariage',
    cat: 'conseils', catLabel: 'Conseils pratiques', emoji: '⚖️',
    gradient: 'linear-gradient(145deg,#2C1F15,#8B6245,#E8A87C)',
    avatarColor: '#E8A87C',
    image: 'https://cdn.shopify.com/s/files/1/0731/1668/0457/files/blog-carte-conseils.webp?v=1773846341',
    title: 'Comparatif : les meilleures solutions de partage photo et vidéo pour mariage',
    excerpt: 'WhatsApp, Google Photos, apps dédiées, QR code... On a testé et comparé chaque solution.',
    date: '20 décembre 2024', readTime: 7, large: true,
    tags: ['comparatif','partage','photo','vidéo','mariage','whatsapp','google photos'],
    url: 'https://www.keepmemoriz.com/blogs/infos/comparatif-les-meilleures-solutions-de-partage-photo-et-video-pour-mariage'
  },
  {
    id: 'album-photo-anniversaire',
    cat: 'anniversaire', catLabel: 'Anniversaire', emoji: '🎂',
    gradient: 'linear-gradient(145deg,#1A1F2C,#2D3D5C,#6B8CC9)',
    avatarColor: '#8B6245',
    image: 'https://cdn.shopify.com/s/files/1/0731/1668/0457/files/blog-carte-anniversaire.webp?v=1773846341',
    title: 'Album photo anniversaire : 5 façons de surprendre vos invités',
    excerpt: "Créer un album photo anniversaire que personne n'attendait. 5 idées concrètes.",
    date: '10 décembre 2024', readTime: 5, large: true,
    tags: ['album','photo','anniversaire','surprise','invités','album'],
    url: 'https://www.keepmemoriz.com/blogs/infos/album-photo-anniversaire-5-facons-de-surprendre-vos-invites'
  },
  {
    id: 'souvenir-baby-shower',
    cat: 'baby-shower', catLabel: 'Baby shower', emoji: '👶',
    gradient: 'linear-gradient(145deg,#2A1F2C,#5C3D60,#C96EB0)',
    avatarColor: '#C96EB0',
    image: 'https://cdn.shopify.com/s/files/1/0731/1668/0457/files/blog-carte-baby-shower.webp?v=1773846341',
    title: 'Baby shower : 10 idées pour garder les meilleurs souvenirs',
    excerpt: 'Votre baby shower va durer quelques heures. Les souvenirs doivent durer toute une vie.',
    date: '28 novembre 2024', readTime: 6,
    tags: ['baby shower','souvenir','photos','vidéos','bébé','album'],
    url: 'https://www.keepmemoriz.com/blogs/infos/baby-shower-10-idees-pour-garder-les-meilleurs-souvenirs'
  },
  {
    id: 'placement-qr-code',
    cat: 'decoration', catLabel: 'Décoration · Mariage', emoji: '📍',
    gradient: 'linear-gradient(145deg,#2C1F15,#6B4A30,#E8D5B0)',
    avatarColor: '#C9A96E',
    image: 'https://cdn.shopify.com/s/files/1/0731/1668/0457/files/blog-carte-decoration.webp?v=1773846341',
    title: 'Où placer le QR code le jour du mariage ? Nos conseils',
    excerpt: 'Le placement du QR code fait la différence entre 30% et 90% de participation.',
    date: '15 novembre 2024', readTime: 5,
    tags: ['qr code','table','mariage','placement','décoration','carte de table'],
    url: 'https://www.keepmemoriz.com/blogs/infos/ou-placer-le-qr-code-le-jour-du-mariage-nos-conseils'
  },
  {
    id: 'whatsapp-photos-mariage',
    cat: 'conseils', catLabel: 'Conseils pratiques', emoji: '⚠️',
    gradient: 'linear-gradient(145deg,#2C1F15,#8B6245,#E8A87C)',
    avatarColor: '#E8A87C',
    image: 'https://cdn.shopify.com/s/files/1/0731/1668/0457/files/blog-carte-conseils.webp?v=1773846341',
    title: "Photos de mariage : pourquoi WhatsApp n'est pas la bonne solution",
    excerpt: 'WhatsApp compresse vos photos à 15% de leur qualité. Voici ce que ça signifie concrètement.',
    date: '5 novembre 2024', readTime: 5,
    tags: ['whatsapp','photos','mariage','compression','qualité','partage'],
    url: 'https://www.keepmemoriz.com/blogs/infos/photos-de-mariage-pourquoi-whatsapp-nest-pas-la-bonne-solution'
  },
  {
    id: 'partage-photo-reunion-famille',
    cat: 'conseils', catLabel: 'Conseils pratiques', emoji: '👨‍👩‍👧‍👦',
    gradient: 'linear-gradient(145deg,#2C2218,#5C3D22,#C9A96E)',
    avatarColor: '#C9A96E',
    image: 'https://cdn.shopify.com/s/files/1/0731/1668/0457/files/blog-carte-conseils.webp?v=1773846341',
    title: 'Réunion de famille : comment centraliser les photos de tout le monde',
    excerpt: 'De 8 à 82 ans, tout le monde prend des photos. Personne ne les partage après.',
    date: '20 octobre 2024', readTime: 5,
    tags: ['réunion','famille','photos','partage','générations','album'],
    url: 'https://www.keepmemoriz.com/blogs/infos/reunion-de-famille-comment-centraliser-les-photos-de-tout-le-monde'
  },
  {
    id: 'album-photo-evjf',
    cat: 'evg', catLabel: 'EVJF / EVG', emoji: '🥂',
    gradient: 'linear-gradient(145deg,#1F2C1A,#3D5C3D,#6BC96E)',
    avatarColor: '#6BC96E',
    image: 'https://cdn.shopify.com/s/files/1/0731/1668/0457/files/blog-carte-evjf.webp?v=1773846341',
    title: "EVJF et EVG : créez un album souvenir que la future mariée adorera",
    excerpt: "L'album photo EVJF que la future mariée gardera toute sa vie.",
    date: '5 octobre 2024', readTime: 5,
    tags: ['evjf','evg','album','photo','future mariée','album'],
    url: 'https://www.keepmemoriz.com/blogs/infos/evjf-et-evg-creez-un-album-souvenir-que-la-future-mariee-adorera'
  },
  {
    id: 'noel-qr-code-famille',
    cat: 'conseils', catLabel: 'Conseils pratiques', emoji: '🎄',
    gradient: 'linear-gradient(145deg,#2C2218,#5C3D22,#C9A96E)',
    avatarColor: '#C9A96E',
    image: 'https://cdn.shopify.com/s/files/1/0731/1668/0457/files/carte_QR_sur_table_noel_2_1.webp?v=1774201404',
    title: "Noël en famille : un QR code pour que personne n'oublie ses photos",
    excerpt: 'Un QR code sur la table de Noël et toute la famille partage ses photos au même endroit.',
    date: '25 septembre 2024', readTime: 4,
    tags: ['noël','famille','qr code','photos','partage','générations'],
    url: 'https://www.keepmemoriz.com/blogs/infos/noel-en-famille-un-qr-code-pour-que-personne-noublie-ses-photos'
  }
];

var ARTICLES_EN = [
  {
    id: 'qr-code-mariage-guide-complet',
    cat: 'mariage', catLabel: 'Wedding', emoji: '💍',
    gradient: 'linear-gradient(145deg,#2C1A14,#7A4A2C,#C9A96E)',
    avatarColor: '#C9A96E',
    image: 'https://cdn.shopify.com/s/files/1/0731/1668/0457/files/blog-carte-mariage.webp?v=1773846341',
    title: 'Wedding QR code: the complete guide for couples-to-be',
    excerpt: 'A QR code on every table, and your guests share their photos without installing anything. How it works, placement tips, real results.',
    date: 'January 15, 2025', readTime: 8, large: true,
    tags: ['qr code','wedding','guide','photos','guests','gallery','sharing','table'],
    url: 'https://www.keepmemoriz.com/blogs/infos/qr-code-mariage-le-guide-complet-pour-les-futurs-maries'
  },
  {
    id: 'idees-animation-photo-mariage',
    cat: 'mariage', catLabel: 'Wedding', emoji: '📷',
    gradient: 'linear-gradient(145deg,#1A2C1F,#2A4A30,#6EC98A)',
    avatarColor: '#6EC98A',
    image: 'https://cdn.shopify.com/s/files/1/0731/1668/0457/files/blog-carte-mariage.webp?v=1773846341',
    title: '7 photo activity ideas for a memorable wedding',
    excerpt: 'Photobooth, polaroid, QR code, photo challenges... 7 tested activities that produce real photos.',
    date: 'January 8, 2025', readTime: 7,
    tags: ['activity','photo','wedding','photobooth','polaroid','qr code','ideas'],
    url: 'https://www.keepmemoriz.com/blogs/infos/7-idees-danimation-photo-pour-un-mariage-memorable'
  },
  {
    id: 'livre-or-numerique-mariage',
    cat: 'mariage', catLabel: 'Wedding', emoji: '📖',
    gradient: 'linear-gradient(145deg,#2C2218,#5C3D22,#C9A96E)',
    avatarColor: '#C9A96E',
    image: 'https://cdn.shopify.com/s/files/1/0731/1668/0457/files/blog-carte-mariage.webp?v=1773846341',
    title: 'Digital vs traditional guest book: which one for your wedding?',
    excerpt: "The paper guest book has charm. The digital one has photos and videos. Do you really have to choose?",
    date: 'January 2, 2025', readTime: 6,
    tags: ['guest book','digital','traditional','wedding','photos','videos'],
    url: 'https://www.keepmemoriz.com/blogs/infos/livre-dor-numerique-vs-traditionnel-lequel-choisir-pour-votre-mariage'
  },
  {
    id: 'comparatif-partage-photo-mariage',
    cat: 'conseils', catLabel: 'Practical tips', emoji: '⚖️',
    gradient: 'linear-gradient(145deg,#2C1F15,#8B6245,#E8A87C)',
    avatarColor: '#E8A87C',
    image: 'https://cdn.shopify.com/s/files/1/0731/1668/0457/files/blog-carte-conseils.webp?v=1773846341',
    title: 'Comparison: the best photo & video sharing solutions for weddings',
    excerpt: 'WhatsApp, Google Photos, dedicated apps, QR code... We tested and compared each solution.',
    date: 'December 20, 2024', readTime: 7, large: true,
    tags: ['comparison','sharing','photo','video','wedding','whatsapp','google photos'],
    url: 'https://www.keepmemoriz.com/blogs/infos/comparatif-les-meilleures-solutions-de-partage-photo-et-video-pour-mariage'
  },
  {
    id: 'album-photo-anniversaire',
    cat: 'anniversaire', catLabel: 'Birthday', emoji: '🎂',
    gradient: 'linear-gradient(145deg,#1A1F2C,#2D3D5C,#6B8CC9)',
    avatarColor: '#8B6245',
    image: 'https://cdn.shopify.com/s/files/1/0731/1668/0457/files/blog-carte-anniversaire.webp?v=1773846341',
    title: 'Birthday photo album: 5 ways to surprise your guests',
    excerpt: "Create a birthday photo album nobody expected. 5 concrete ideas.",
    date: 'December 10, 2024', readTime: 5, large: true,
    tags: ['album','photo','birthday','surprise','guests','gallery'],
    url: 'https://www.keepmemoriz.com/blogs/infos/album-photo-anniversaire-5-facons-de-surprendre-vos-invites'
  },
  {
    id: 'souvenir-baby-shower',
    cat: 'baby-shower', catLabel: 'Baby shower', emoji: '👶',
    gradient: 'linear-gradient(145deg,#2A1F2C,#5C3D60,#C96EB0)',
    avatarColor: '#C96EB0',
    image: 'https://cdn.shopify.com/s/files/1/0731/1668/0457/files/blog-carte-baby-shower.webp?v=1773846341',
    title: 'Baby shower: 10 ideas to keep the best memories',
    excerpt: 'Your baby shower will last a few hours. The memories should last a lifetime.',
    date: 'November 28, 2024', readTime: 6,
    tags: ['baby shower','memory','photos','videos','baby','gallery'],
    url: 'https://www.keepmemoriz.com/blogs/infos/baby-shower-10-idees-pour-garder-les-meilleurs-souvenirs'
  },
  {
    id: 'placement-qr-code',
    cat: 'decoration', catLabel: 'Decoration · Wedding', emoji: '📍',
    gradient: 'linear-gradient(145deg,#2C1F15,#6B4A30,#E8D5B0)',
    avatarColor: '#C9A96E',
    image: 'https://cdn.shopify.com/s/files/1/0731/1668/0457/files/blog-carte-decoration.webp?v=1773846341',
    title: 'Where to place the QR code on the wedding day? Our tips',
    excerpt: 'QR code placement makes the difference between 30% and 90% guest participation.',
    date: 'November 15, 2024', readTime: 5,
    tags: ['qr code','table','wedding','placement','decoration','poster'],
    url: 'https://www.keepmemoriz.com/blogs/infos/ou-placer-le-qr-code-le-jour-du-mariage-nos-conseils'
  },
  {
    id: 'whatsapp-photos-mariage',
    cat: 'conseils', catLabel: 'Practical tips', emoji: '⚠️',
    gradient: 'linear-gradient(145deg,#2C1F15,#8B6245,#E8A87C)',
    avatarColor: '#E8A87C',
    image: 'https://cdn.shopify.com/s/files/1/0731/1668/0457/files/blog-carte-conseils.webp?v=1773846341',
    title: "Wedding photos: why WhatsApp isn't the right solution",
    excerpt: 'WhatsApp compresses your photos to 15% of their quality. Here is what that means in practice.',
    date: 'November 5, 2024', readTime: 5,
    tags: ['whatsapp','photos','wedding','compression','quality','sharing'],
    url: 'https://www.keepmemoriz.com/blogs/infos/photos-de-mariage-pourquoi-whatsapp-nest-pas-la-bonne-solution'
  },
  {
    id: 'partage-photo-reunion-famille',
    cat: 'conseils', catLabel: 'Practical tips', emoji: '👨‍👩‍👧‍👦',
    gradient: 'linear-gradient(145deg,#2C2218,#5C3D22,#C9A96E)',
    avatarColor: '#C9A96E',
    image: 'https://cdn.shopify.com/s/files/1/0731/1668/0457/files/blog-carte-conseils.webp?v=1773846341',
    title: "Family reunion: how to centralize everyone's photos",
    excerpt: "From age 8 to 82, everyone takes photos. Nobody shares them afterwards.",
    date: 'October 20, 2024', readTime: 5,
    tags: ['reunion','family','photos','sharing','generations','gallery'],
    url: 'https://www.keepmemoriz.com/blogs/infos/reunion-de-famille-comment-centraliser-les-photos-de-tout-le-monde'
  },
  {
    id: 'album-photo-evjf',
    cat: 'evg', catLabel: 'Bachelorette / Bachelor', emoji: '🥂',
    gradient: 'linear-gradient(145deg,#1F2C1A,#3D5C3D,#6BC96E)',
    avatarColor: '#6BC96E',
    image: 'https://cdn.shopify.com/s/files/1/0731/1668/0457/files/blog-carte-evjf.webp?v=1773846341',
    title: 'Bachelorette & bachelor party: create a memory album the bride will love',
    excerpt: "The bachelorette photo album the bride-to-be will keep for life.",
    date: 'October 5, 2024', readTime: 5,
    tags: ['bachelorette','bachelor','album','photo','bride','gallery'],
    url: 'https://www.keepmemoriz.com/blogs/infos/evjf-et-evg-creez-un-album-souvenir-que-la-future-mariee-adorera'
  },
  {
    id: 'noel-qr-code-famille',
    cat: 'conseils', catLabel: 'Practical tips', emoji: '🎄',
    gradient: 'linear-gradient(145deg,#2C2218,#5C3D22,#C9A96E)',
    avatarColor: '#C9A96E',
    image: 'https://cdn.shopify.com/s/files/1/0731/1668/0457/files/carte_QR_sur_table_noel_2_1.webp?v=1774201404',
    title: "Family Christmas: a QR code so nobody forgets their photos",
    excerpt: 'A QR code on the Christmas table and the whole family shares their photos in one place.',
    date: 'September 25, 2024', readTime: 4,
    tags: ['christmas','family','qr code','photos','sharing','generations'],
    url: 'https://www.keepmemoriz.com/blogs/infos/noel-en-famille-un-qr-code-pour-que-personne-noublie-ses-photos'
  }
];

var ARTICLES = KM_LANG === 'en' ? ARTICLES_EN : ARTICLES_FR;

var FEATURED_ARTICLE_FR = {
  id: 'article-mariage-photos-invites',
  cat: 'mariage', catLabel: 'Mariage', emoji: '💍',
  gradient: 'linear-gradient(145deg,#2C1F14,#6B4A30,#C9A96E)',
  heroImage: 'https://cdn.shopify.com/s/files/1/0731/1668/0457/files/blog-hero-mariage-invites.webp?v=1773846341',
  title: 'Comment récupérer les photos de tous vos invités de mariage',
  date: '20 janvier 2025', readTime: 8,
  tags: ['récupérer','photos','invités','mariage','qr code','album','jour j'],
  url: 'https://www.keepmemoriz.com/blogs/infos/comment-recuperer-les-photos-de-tous-vos-invites-de-mariage'
};

var FEATURED_ARTICLE_EN = {
  id: 'article-mariage-photos-invites',
  cat: 'mariage', catLabel: 'Wedding', emoji: '💍',
  gradient: 'linear-gradient(145deg,#2C1F14,#6B4A30,#C9A96E)',
  heroImage: 'https://cdn.shopify.com/s/files/1/0731/1668/0457/files/blog-hero-mariage-invites.webp?v=1773846341',
  title: 'How to collect all your wedding guests\' photos',
  date: 'January 20, 2025', readTime: 8,
  tags: ['collect','photos','guests','wedding','qr code','gallery','big day'],
  url: 'https://www.keepmemoriz.com/blogs/infos/comment-recuperer-les-photos-de-tous-vos-invites-de-mariage'
};

var FEATURED_ARTICLE = KM_LANG === 'en' ? FEATURED_ARTICLE_EN : FEATURED_ARTICLE_FR;


/* ════════════════════════════════════════════════════════════════════
   LOGIC
════════════════════════════════════════════════════════════════════ */
var currentCat = 'tous';
var searchQuery = '';
var visibleCount = 6;
var PAGE_SIZE = 6;
var filteredArticles = [];

function articleMatchesQuery(article, q) {
  if (!q || q.length < 2) return true;
  var lower = q.toLowerCase();
  if (article.title.toLowerCase().indexOf(lower) !== -1) return true;
  if (article.excerpt && article.excerpt.toLowerCase().indexOf(lower) !== -1) return true;
  if (article.catLabel && article.catLabel.toLowerCase().indexOf(lower) !== -1) return true;
  if (article.tags && article.tags.some(function(t) { return t.toLowerCase().indexOf(lower) !== -1; })) return true;
  return false;
}

function highlightText(text, query) {
  if (!query || query.length < 2) return text;
  var escaped = query.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  return text.replace(new RegExp('(' + escaped + ')', 'gi'), '<mark>$1</mark>');
}

function buildCardHTML(article, query) {
  query = query || '';
  var title = highlightText(article.title, query);
  var excerpt = highlightText(article.excerpt, query);
  var isLarge = article.large;
  var imgStyle = article.image
    ? "background:url('" + article.image + "') center/cover"
    : 'background:' + article.gradient;
  var articleUrl = article.url || '#';
  return '<div class="article-card' + (isLarge ? ' article-large' : '') + '" data-id="' + article.id + '" data-cat="' + article.cat + '">' +
    '<a href="' + articleUrl + '" class="article-card-img" style="' + imgStyle + '">' +
    '<div class="article-card-img-inner">' + (article.image ? '' : article.emoji) + '</div>' +
    '<div class="article-card-tag">' + article.catLabel.split(' · ')[0] + '</div>' +
    '</a>' +
    '<div class="article-card-body">' +
    '<div class="article-card-meta">' +
    '<span class="article-card-cat">' + article.catLabel + '</span>' +
    '<span class="article-card-date">' + article.date + '</span>' +
    '</div>' +
    '<h3>' + title + '</h3>' +
    '<p>' + excerpt + '</p>' +
    '<div class="article-card-footer">' +
    '<div class="article-card-author-mini">' +
    '<div class="mini-avatar" style="background:' + article.avatarColor + '">KM</div>' +
    '<span class="mini-name">KeepMemoriz</span>' +
    '<span class="read-time-label">· ' + article.readTime + ' ' + BLOG_UI.min + '</span>' +
    '</div>' +
    '<a href="' + articleUrl + '" class="article-card-link">' + BLOG_UI.readCta + '</a>' +
    '</div></div></div>';
}

function renderGrid() {
  var grid = document.getElementById('articlesGrid');
  var noRes = document.getElementById('noResults');
  var loadBtn = document.getElementById('loadMoreBtn');
  var titleEl = document.getElementById('sectionTitle');

  filteredArticles = ARTICLES.filter(function(a) {
    var matchCat = currentCat === 'tous' || a.cat === currentCat;
    var matchSearch = articleMatchesQuery(a, searchQuery);
    return matchCat && matchSearch;
  });

  titleEl.innerHTML = searchQuery.length >= 2
    ? BLOG_UI.resultsFor + ' <em>"' + searchQuery + '"</em>'
    : (BLOG_UI.catLabels[currentCat] || BLOG_UI.allArticles);

  var countEl = document.getElementById('searchCount');
  if (searchQuery.length >= 2) {
    var featuredMatch = articleMatchesQuery(FEATURED_ARTICLE, searchQuery);
    var total = filteredArticles.length + (featuredMatch ? 1 : 0);
    countEl.textContent = total === 0
      ? BLOG_UI.noResults + ' "' + searchQuery + '"'
      : total + ' ' + BLOG_UI.articlesFound + ' "' + searchQuery + '"';
  } else {
    countEl.textContent = '';
  }

  if (filteredArticles.length === 0) {
    grid.innerHTML = '';
    noRes.style.display = 'block';
    loadBtn.classList.add('hidden');
    return;
  }

  noRes.style.display = 'none';
  grid.innerHTML = filteredArticles.slice(0, visibleCount).map(function(a) { return buildCardHTML(a, searchQuery); }).join('');

  if (filteredArticles.length > visibleCount) {
    var rem = filteredArticles.length - visibleCount;
    loadBtn.classList.remove('hidden');
    loadBtn.disabled = false;
    loadBtn.textContent = BLOG_UI.loadMore + ' (' + rem + ' ' + BLOG_UI.remaining + ')';
  } else {
    loadBtn.classList.add('hidden');
  }

  grid.classList.remove('visible');
  requestAnimationFrame(function() { if (typeof io !== 'undefined') io.observe(grid); });
}

function loadMore() {
  visibleCount += PAGE_SIZE;
  renderGrid();
}

/* Category filters */
document.querySelectorAll('.cat-btn').forEach(function(btn) {
  btn.addEventListener('click', function() {
    document.querySelectorAll('.cat-btn').forEach(function(b) { b.classList.remove('active'); });
    btn.classList.add('active');
    currentCat = btn.dataset.cat;
    visibleCount = PAGE_SIZE;
    searchQuery = '';
    document.getElementById('searchInput').value = '';
    document.getElementById('searchCount').textContent = '';
    renderGrid();
  });
});

/* Search */
var searchTimer;
document.getElementById('searchInput').addEventListener('input', function(e) {
  clearTimeout(searchTimer);
  searchTimer = setTimeout(function() {
    searchQuery = e.target.value.trim();
    visibleCount = PAGE_SIZE;
    if (searchQuery.length >= 2) {
      currentCat = 'tous';
      document.querySelectorAll('.cat-btn').forEach(function(b) { b.classList.remove('active'); });
      document.querySelector('[data-cat="tous"]').classList.add('active');
    }
    renderGrid();
  }, 200);
});

/* Related articles */
function buildRelated(article) {
  var same = ARTICLES.filter(function(a) { return a.id !== article.id && a.cat === article.cat; });
  var other = ARTICLES.filter(function(a) { return a.id !== article.id && a.cat !== article.cat; });
  var relatedGrid = document.getElementById('relatedGrid');
  if (relatedGrid) {
    relatedGrid.innerHTML = same.concat(other).slice(0, 3).map(function(a) { return buildCardHTML(a); }).join('');
  }
}

/* Open article: redirect to native Shopify article */
function openArticle(id) {
  var article = id === FEATURED_ARTICLE.id ? FEATURED_ARTICLE : ARTICLES.find(function(a) { return a.id === id; });
  if (article && article.url) {
    window.location.href = article.url;
  }
}

function closeArticle() {
  document.getElementById('gridSection').scrollIntoView({ behavior: 'smooth', block: 'start' });
}

/* Animations */
var io = new IntersectionObserver(function(entries) {
  entries.forEach(function(x) {
    if (!x.isIntersecting) return;
    x.target.classList.add('visible');
    io.unobserve(x.target);
  });
}, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });

document.querySelectorAll('.reveal, .stagger').forEach(function(el) { io.observe(el); });

/* Init */
renderGrid();